import { render, staticRenderFns } from "./WhiteLabelShare.vue?vue&type=template&id=77b0aa13&scoped=true"
import script from "./WhiteLabelShare.vue?vue&type=script&lang=js"
export * from "./WhiteLabelShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b0aa13",
  null
  
)

export default component.exports